export enum sizeOptions {
  xs = "xs",
  sm = "sm",
  md = "md",
  lg = "lg",
}
